import axios from 'axios';
import { logError } from 'Utils/Logger';
import { isNonAnonymousUser, getAccessToken } from 'Utils/UserCookie';
import { createApiTokenHandler } from './RefreshTokenHandler';

export class RequestService {
  static send(config) {
    const { authenticate = false, customHeaders = {} } = config;

    return createApiTokenHandler(async (fetchNewToken) => {
      try {
        const token = isNonAnonymousUser() && getAccessToken();

        const headers = customHeaders;

        if (authenticate && token) {
          headers.Authorization = `Bearer ${token}`;
        }

        return await axios({ ...config, headers });
      } catch (error) {
        logError(error.response?.message);
        if (error.code === 401 || error.statusCode === 401 || error.response?.status === 401) {
          return fetchNewToken();
        }
        return error;
      }
    });
  }
}
